import { get } from 'lodash'
import { NextSeo } from 'next-seo'
import { ComponentType } from 'react'
import { useIntl } from 'react-intl'
import { RoleModel } from 'utils/role'

interface Props {
  role?: RoleModel
  category?: any
  zone?: any
}

export const SEO: ComponentType<Props> = ({ category, role, zone }) => {
  const { formatMessage } = useIntl()

  return (
    <NextSeo
      title={formatMessage(
        { id: 'search.head.title' },
        {
          role: role ? formatMessage({ id: role.uuid }) : 'en venta y renta',
          category: get(category, 'pluralName', 'Propiedades'),
          zone: get(zone, 'name', 'Mérida y Yucatán'),
        },
      )}
      description={formatMessage(
        { id: 'search.head.description' },
        {
          role: role ? formatMessage({ id: role.uuid }) : 'en venta y renta',
          category: get(category, 'pluralName', 'Propiedades'),
          zone: get(zone, 'name', 'Mérida y Yucatán'),
        },
      )}
    />
  )
}
